import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { UNAUTHORIZED, BAD_REQUEST, FORBIDDEN } from "http-status-codes";
import { Observable,throwError } from 'rxjs';
import notify from 'devextreme/ui/notify';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private injector: Injector) { }

  handleError(error: any) {
   
    let router = this.injector.get(Router);
    console.log('URL: ' + router.url);
    let httpErrorCode = error.httpErrorCode;
    if (error instanceof HttpErrorResponse) {
      //Backend returns unsuccessful response codes such as 404, 500 etc.				  
      console.error('Backend returned status code: ', error.status);
      console.error('Response body:', error.message);  
      
      notify({
        message: error.message,
        position: {
          my: 'Top right', 
          at: 'Top right', 
          of: window, 
          offset: '0 0' 
        }
    }, "error", 3000);
      switch (httpErrorCode) {
        case UNAUTHORIZED:
          router.navigateByUrl("/login");
          break;
        case FORBIDDEN:
          router.navigateByUrl("/unauthorized");
          break;
        case BAD_REQUEST:
          //showError(error.message);
          break;
        default:
        //this.showError(REFRESH_PAGE_ON_TOAST_CLICK_MESSAGE);
      }

    } else {
      //A client-side or network error occurred.	          
      console.error('An error occurred:', error.message);
    }
    return (error);
    ////router.navigate(['/error']);
   // router.navigate([router.url]);
  }
} 
